// extracted by mini-css-extract-plugin
module.exports = {"searchbar":"OrganizationDiscoveryList_searchbar__fOezu","rowTextContainer":"OrganizationDiscoveryList_rowTextContainer__UCXmm"};